import { IconWTM } from 'src/assets/icons/IconWTM';
import { IconEditor, IconLongForm } from 'src/assets/icons/navbar-links';
import { PROJECT_TYPE } from 'src/data/project';

const ICONS = {
  [PROJECT_TYPE.document]: IconEditor,
  [PROJECT_TYPE.blogPostBuilder]: IconLongForm,
  [PROJECT_TYPE.longFormBuilder]: IconLongForm,
  [PROJECT_TYPE.wtmHomePage]: IconWTM,
  [PROJECT_TYPE.continuousOptimization]: IconWTM,
};

export const getProjectTypeIcon = (projectType) => ICONS[projectType];
